<template>
  <v-container style="height: 100%; overflow: auto; max-width: 1200px; margin: 0 auto;" :class="`hideScroll ${$vuetify.theme.dark? 'dark' : ''}`">
    <div class="pt-5 d-flex align-center">
      <v-btn
        v-tooltip="'Suodata'"
        fab
        large
        color="primary"
        @click="showFilter = true"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
      <!-- <v-btn
        v-if="!selecting"
        fab
          small
          @click="setSelecting(); allSelected = false"
          v-tooltip="$t('filter.batch')"
          class="ml-4 mt-1"
        >
          <v-icon>
            mdi-check
          </v-icon>
      </v-btn>
      <v-btn
        v-else
        fab
        small
        @click="setSelecting"
        v-tooltip="$t('filter.batch_cancel')"
        class="ml-4 mt-1"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn> -->
      <v-btn @click="quick = true" class="ml-4 mt-1" small>
        <v-icon class="mr-3">mdi-clock-fast</v-icon>
        Pikasuodatus
      </v-btn>
    </div>
    <div class="mt-4 mb-4 pa-0" v-if="selecting">
      <!-- :disabled="selectedItems.length < 1" -->
      <v-btn
        color="red"
        :disabled="selectedItems.length < 1"
        @click="deleting = true"
        v-if="selecting"
        class="ml-1"
      >
        {{ $t('delete') }}
        <v-icon class="ml-1" small>mdi-delete</v-icon>
      </v-btn>
      <!-- :disabled="selectedItems.length < 1" -->
      <v-btn
        v-if="selecting"
        :disabled="selectedItems.length < 1"
        class="ml-1"
        @click="choosing = true"
      >
        {{$t('analysis.add_to_folder')}}
        <v-icon class="ml-1" small>mdi-folder-outline</v-icon>
      </v-btn>
      <v-btn
      class="ml-1"
      @click="selectAll"
      >
        {{ allSelected ? $t('filter.cancel_select_all') : $t('filter.select_all')}}
      </v-btn>
    </div>
    <v-row class="mt-6">
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="4"
        xl="3"
        v-for="filter in filters.filter(f => !f.only_me)"
        :key="'filteritem' + filter.filter_id"
        style="padding: 5px;"
      >
        <filter-item
          :selecting="selecting"
          :filter="filter"
          @toggleSelection="handleSelection($event)"
        ></filter-item>
      </v-col>
    </v-row>
    <h3 class="mt-12">
      <v-icon>mdi-account-outline</v-icon>
      Näkyy vain minulle</h3>
    <v-row class="mt-6">
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="4"
        xl="3"
        v-for="filter in filters.filter(f => f.only_me)"
        :key="'filteritem' + filter.filter_id"
        style="padding: 5px;"
      >
        <filter-item
          :selecting="selecting"
          :unable-to-add-to-folder="true"
          :filter="filter"
          @toggleSelection="handleSelection($event)"
        ></filter-item>
      </v-col>
    </v-row>
    <div
      v-if="filters.length == 0 && !loading"
      style="text-align: center;"
    >
      <v-icon size="100">mdi-filter-outline</v-icon>
      <h2>{{$t('filters.no_filters')}}</h2>
      <v-btn
        @click="showFilter = true"
        class="mt-6"
        color="primary"
      >
        {{$t('filters.add_filter')}}
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <div v-else-if="loading" class="d-flex justify-center">
      <v-progress-circular
        indeterminate
      ></v-progress-circular>
    </div>
    <CreateFilterDialog
      :show="showFilter"
      :loading="loading"
      @close="showFilter = false"
      @save="search($event, false)"
      @search="search($event, true)"
      @input="filter = $event"
    />
    <v-dialog max-width="600" :fullscreen="$vuetify.breakpoint.mobile" v-model="quick">
      <QuickFilter @search="search($event)" />
    </v-dialog>
    <ConfirmationDialog
      :show="deleting"
      :subText="$t('filter.confirm_batch_delete')"
      btnColor="red"
      :btnText="$t('delete')"
      :text="$t('filter.delete_filter')"
      @decline="deleting = false"
      @accept="acceptDeleting()"
    />
    <ChooseFolder
      v-if="choosing"
      :visible="choosing"
      :value="chosenFolders"
      :limit="1"
      :loading="addingToFolder"
      @input="chosenFolders = $event"
      @cancel="choosing = false; chosenFolders = []"
      @set="confirmAddToFolder()"
      :text="$t('analysis.add_to_folder')"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateFilterDialog from '@/components/filters/CreateFilterDialog.vue'
import FilterItem from '@/components/filters/FilterItem.vue'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import QuickFilter from '@/components/filters/QuickFilter.vue'
import ChooseFolder from '@/components/folder/ChooseFolder.vue'
export default {
  components: {
    CreateFilterDialog,
    FilterItem,
    ConfirmationDialog,
    ChooseFolder,
    QuickFilter
  },
  created() {
    this.initFilters()
      .catch(e => this.error(e))
  },
  deforeDestroy() {
    this.clearItems()
  },
  data: () => ({
    saving: false,
    selecting: false,
    deleting: false,
    choosing: false,
    chosenFolders: [],
    addingToFolder: false,
    allSelected: false,
    quick: false,
    showFilter: false,
    filter: null
  }),
  methods: {
    setSelecting() {
      if(this.selecting) this.clearItems()
      this.selecting = !this.selecting
    },
    search(filter, openFilter = true) {
      if(!filter.save) {
        this.$router.push(`/filter/nosave?filter=${JSON.stringify(filter)}`)
        return
      }

      this.postFilter(filter)
        .then(async e => {
          this.showFilter = false
          this.success(this.$t('filter.filter_saved'))
          const addToFolderProms = filter.folderIds.map(id => {
            return this.addFolder({
              parent: id,
              name: filter.title,
              type: 'filter',
              filter_id: e.data.filter_id
            })
          })

          await Promise.all(addToFolderProms)
            .catch(e => this.error(e))

          if(openFilter) this.$router.push(`/filter/${e.data.filter_id}`)
        })
        .catch(e => this.error(e))
        .finally(() => {this.saving = false})
    },
    acceptDeleting() {
      this.deleteSelectedItems()
      .then(() => {
          this.success(this.$t('filter.filters_deleted'))
        })
        .catch(e => this.error(e))
        .finally(() => {
          this.allSelected = false,
          this.selecting = false
          this.deleting = false
          this.clearItems()
        })
    },
    confirmAddToFolder() {
      const folder = this.chosenFolders && this.chosenFolders[0]
      if(!folder) return
      this.addAllToFolder(folder)
    },
    addAllToFolder(folder) {
      this.addingToFolder = true
      this.batchAddItems(folder.id)
      .then(() => {
        let folderName = folder.name
        if (!folderName) folderName = this.$t('library.library')
        this.success(this.$t('filter.filters_added') + folderName + "!")
      })
      .catch(e => this.error(e))
      .finally(() => {
        this.addingToFolder = false
        this.allSelected = false
        this.selecting = false
        this.choosing = false
        this.chosenFolders = []
        this.clearItems()
      })
    },
    handleSelection(filter) {
      if(this.selectedItems.includes(filter)) this.removeItem(filter)
      else this.addItem(filter)
    },
    selectAll() {
      if (!this.allSelected) {
        this.allSelected = true
        for(let items of this.filters) {
          this.addItem(items)
        }
      }
      else {
        this.allSelected = false
        for(let items of this.filters) {
          this.removeItem(items)
        }
      }
    },
    ...mapActions('filter', [
      'postFilter',
      'initFilters'
    ]),
    ...mapActions('folder', [
      'addFolder'
    ]),
    ...mapActions('noti', [
      'error',
      'success'
    ]),
    ...mapActions('batch', [
      'clearItems',
      'addItem',
      'removeItem',
      'deleteSelectedItems',
      'batchAddItems'
    ])
  },
  computed: {
    ...mapGetters('filter', [
      'filters',
      'loading'
    ]),
    ...mapGetters('tag', [
      'tag_groups'
    ]),
    ...mapGetters('user', [
      'leagueId'
    ]),
    ...mapGetters('batch', [
      'selectedItems'
    ])
  }
}
</script>

<style scoped>
.dark {
  background-color: #121212;
}
</style>